import { useMemo } from 'react';

import { useInitUserTracking } from '../hooks/useInitUserTracking';
import { useGetCurrentProviderQuery } from './useGetCurrentProviderQuery';

export function useInitProviderUserTracking() {
  const providerShortId = useGetCurrentProviderQuery().data?.currentProvider?.shortId;
  const additionalVars = useMemo(
    () =>
      providerShortId
        ? {
            providerShortId,
          }
        : {},
    [providerShortId],
  );
  useInitUserTracking(providerShortId, additionalVars);
}
